import {
  issueTypeInfoBoxData,
  issueTypeTextAreaData,
} from '@abvehicles/constants/questionData';
import { useAbVehiclesStore } from '@abvehicles/store/store';
import { IssueType } from '@abvehicles/types/issue-types';
import {
  InformationBox,
  TextArea,
} from '@molecules/InformationBox/InformationBox';
import { ErrorMessages } from '@types';

interface AdditionalQuestionProps {
  errorPath: string;
  errorMessages: ErrorMessages[];
  selectedIssueType: IssueType | null;
  setErrorMessages: (errorMessages: ErrorMessages[]) => void;
}

export const AdditionalQuestion = ({
  errorPath,
  errorMessages,
  setErrorMessages,
  selectedIssueType,
}: AdditionalQuestionProps) => {
  const { issueType, updateIssueType } = useAbVehiclesStore();
  const infoBoxData = issueTypeInfoBoxData;
  const textAreaData = issueTypeTextAreaData;
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setErrorMessages([]);
    updateIssueType({
      ...issueType,
      additionalInfo: event.target.value,
    });
  };
  if (selectedIssueType === IssueType.NONE_OF_THE_ABOVE) {
    return (
      <div className="flex flex-col gap-3">
        <InformationBox
          infoText={infoBoxData.infoText}
          variant="warning"
          title={infoBoxData.title}
          data-testid="info-box"
        />
        <TextArea
          labelText={textAreaData.labelText}
          description={textAreaData.description}
          id={errorPath}
          onChange={handleChange}
          value={issueType.additionalInfo}
          isLabelTextTitle={false}
          maxLength={textAreaData.maxLength}
          errorPath={errorPath}
          errorMessages={errorMessages}
          showCounter={true}
        />
      </div>
    );
  }
  return null;
};
